'use strict'


$(function() { 

    if ($('.js-slick').length) {
        $('.js-slick').slick({
            prevArrow: '<button type="button" class="slick-prev  slick-arrow"></button>',
            nextArrow: '<button type="button" class="slick-next  slick-arrow"></button>',
            
            dots: true
        });
    }
    
    
    if ($('.js-slick-company').length) {
        $('.js-slick-company').slick({
            prevArrow: '<button type="button" class="slick-prev  slick-arrow"></button>',
            nextArrow: '<button type="button" class="slick-next  slick-arrow"></button>',
            
            dots: false
        });
    }

});